import { render, staticRenderFns } from "./Howplay.vue?vue&type=template&id=0e06d9b6&scoped=true&"
import script from "./Howplay.vue?vue&type=script&lang=js&"
export * from "./Howplay.vue?vue&type=script&lang=js&"
import style0 from "./Howplay.vue?vue&type=style&index=0&id=0e06d9b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e06d9b6",
  null
  
)

export default component.exports